/* eslint-disable react/prop-types */
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonAvatar from "components/ArgonAvatar";
import EditIcon from "@mui/icons-material/Edit";
import ArgonButton from "components/ArgonButton";

function CounselorAuthor({ image, name }) {
  return (
    <ArgonBox display="flex" alignItems="center" px={1} py={0.5}>
      <ArgonBox mr={2}>
        <ArgonAvatar src={image} alt={name} size="md" variant="rounded" />
      </ArgonBox>
      <ArgonBox display="flex" flexDirection="column">
        <ArgonTypography variant="button" fontWeight="medium" color="dark">
          {name}
        </ArgonTypography>
      </ArgonBox>
    </ArgonBox>
  );
}

const CounselorDetailsTableData = (counselors, handleEditClick) => {
  // Handle both array and single object cases
  const counselorsArray = Array.isArray(counselors) ? counselors : [counselors];

  return {
    columns: [
      { name: "sno", align: "center" },
      { name: "counselor", align: "left" },
      { name: "phone", align: "center" },
      { name: "description", align: "left" },
      { name: "action", align: "center" },
    ],

    rows: counselorsArray.map((counselor, index) => ({
      sno: (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          {index + 1}
        </ArgonTypography>
      ),
      counselor: <CounselorAuthor image={counselor.image} name={counselor.name} />,
      phone: (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          {counselor.phone}
        </ArgonTypography>
      ),
      description: (
        <ArgonBox>
          <ArgonTypography variant="caption" color="text">
            {counselor.description?.length > 50
              ? `${counselor.description.substring(0, 50)}...`
              : counselor.description}
          </ArgonTypography>
        </ArgonBox>
      ),
      action: (
        <ArgonBox display="flex" gap={1}>
          <ArgonButton
            variant="text"
            color="info"
            size="medium"
            onClick={() => handleEditClick(counselor)}
          >
            <EditIcon fontSize="large" />
          </ArgonButton>
        </ArgonBox>
      ),
    })),
  };
};

export default CounselorDetailsTableData;
